import { render } from "./flightinfosmall.vue?vue&type=template&id=a0995270"
import script from "./flightinfosmall.vue?vue&type=script&lang=js"
export * from "./flightinfosmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__